import { render, staticRenderFns } from "./MailingListList.vue?vue&type=template&id=62d7735b&"
import script from "./MailingListList.vue?vue&type=script&lang=js&"
export * from "./MailingListList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports